<template>
  <div class="account-manager">
    <div class="account-manager-l">
      <h4 class="am-name">
        {{infoGetter.userName}}
      </h4>
      <div class="am-tag">{{ renewInfoData ? '客户成功顾问' : '客户经理'}}</div>
      <!-- <p class="am-position">海智在线 买家部主管</p> -->
      <div class="am-info-item">
        <span class="am-info-item-label">手机:</span>
        <span class="am-info-item-value">{{infoGetter.phone}}</span>
      </div>
      <div class="am-info-item">
        <span class="am-info-item-label">座机:</span>
        <span class="am-info-item-value">{{infoGetter.tel}}</span>
      </div>
      <div class="am-info-item">
        <span class="am-info-item-label">邮箱:</span>
        <a class="am-info-item-value email" :href="`mailto:${infoGetter.email}`">{{infoGetter.email}}</a>
      </div>
    </div>
    <!-- <img class="am-qrcode" src="https://dummyimage.com/120x120/333/fff" alt="" /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getRenewalInfo } from '@/utils/api/dashboard';
export default {
  data(){
    return{
      renewInfoData: null
    }
  },
  computed: {
    ...mapGetters(['salesInfoGetter']),
    infoGetter() {
      return this.renewInfoData || this.salesInfoGetter;
    }
  },
  methods:{
    getRenewalInfo() {
      getRenewalInfo()
        .then(res=> {
          if(res?.rspResult?.bizCode == 200) {
            this.renewInfoData = res.data
          }
        })
        .catch(err=> {
          console.error('查询续约经理信息失败', err)
        })
    }
  },
  mounted(){
  },
  created() {
    this.getRenewalInfo()
    this.$store.dispatch('getSalesInfo');
  }
}
</script>


<style lang="scss" scoped>
.account-manager {
  background: #fff;
  padding: 20px 20px 20px 20px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 1px 6px 0 #001e3b12;
  flex-wrap: wrap;
  &-l {
    .am-name {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      font-family: SourceHanSansCN-Bold;
      font-weight: 700;
      font-size: 16px;
      color: #16181A;
      letter-spacing: 0;
      margin-bottom: 23px;
    }
    .am-tag {
      margin-left: 8px;
      position: relative;
      top:-2px;
      display: inline-block;
      // vertical-align: bottom;
      height: 18px;
      line-height: 18px;
      padding: 0 8px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #4F5D78;
      letter-spacing: 0;
      background: #F5F7FA;
      border-radius: 2px;
    }
    // .am-position {
    //   margin-top: 10px;
    //   margin-bottom: 23px;
    //   height: 12px;
    //   line-height: 12px;
    //   font-family: SourceHanSansCN-Regular;
    //   font-weight: 400;
    //   font-size: 12px;
    //   color: #4F5D78;
    //   letter-spacing: 0;
    // }
    .am-info-item {
      // height: 14px;
      line-height: 14px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      letter-spacing: 0;
      margin-bottom: 16px;
      display: flex;
      &-label {
        color: #4F5D78;
        margin-right: 8px;
        width: max-content;
        flex-shrink: 0;
      }
      &-value {
        color: #16181A;
        &.email {
          color: #066EB7;
        }
      }
      &:nth-last-child(1) {
        margin-bottom: 0;
      }
    }
  }
  .am-qrcode {
    margin-left: 15px;
    width: 120px;
    height: 120px;
  }
}
</style>